// RequireOwnProfile.js

// import { Dialog } from '@mui/material'; // Unused
import ConnectOwnProfile from 'layouts/dashboard/components/ConnectOwnProfile';

const RequireOwnProfile = ({ isVerified, hasOwnProfiles, userRole, loading, initialLoadComplete, children }) => {
    // 1. Loading Checks (Wait for verified first)
    // If not yet verified, we can't determine profile status safely
    if ((isVerified === null || loading || hasOwnProfiles === null) && !initialLoadComplete) {
        return null; // Or a loading spinner
    }

    // [NEW] Demo User Bypass
    if (userRole === "demo_viewer") {
        return children;
    }

    // 2. Verified but No Profile -> Show Forced Modal
    if (isVerified && hasOwnProfiles === false) {
        return (
            <ConnectOwnProfile
                open={true}
                canClose={false}
            />
        );
    }

    // 3. Has Profile -> Allow Access
    return children;
};

export default RequireOwnProfile;